import { render, staticRenderFns } from "./ProjectConfigMgmtView_New.vue?vue&type=template&id=3b57a72c&scoped=true&"
import script from "./ProjectConfigMgmtView_New.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigMgmtView_New.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigMgmtView_New.vue?vue&type=style&index=0&id=3b57a72c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57a72c",
  null
  
)

export default component.exports